module.exports = __webpack_public_path__ + "static/media/editor_many_large.1c7b4253.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/editor_many_large.png
// module id = 393
// module chunks = 16